// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"53d2c002","396":"37f3524f","455":"a6afaa58","977":"ffef5497"}[chunkId] + ".chunk.js";
};